// utils/geo.js
export const defaultCenter = { lat: 29.6785171, lng: -95.6295128 };   // same NY fallback
 
/** Try geolocation up to 3× (0 s, +1 s, +2 s) before calling fallback */
export function attemptGeo(success, fallback, tries = 0) {
    navigator.geolocation.getCurrentPosition(
      success,
      () => {
        if (tries < 2)                                 // retry twice
          setTimeout(() => attemptGeo(success, fallback, tries + 1), 1000);
        else                                           // third miss → fallback
          fallback();
      },
      { enableHighAccuracy: true, timeout: 2000 }
    );
  }